const data = {
    "videoUrl": "https://coresource.zhanhuo.com/video/228KV.mp4"
}
export default data